/** An agent's conversations about an organization: a GET lists the user's, newest first, and a POST starts one. */
export const agentConversationsUrl = (organizationId: number, agentKey: string): string =>
  `/sysconfig/api/v1/organizations/${organizationId}/agents/${agentKey}/conversations`;

/** One conversation: a GET reads it with its turns, and a PATCH renames it. */
export const agentConversationUrl = (conversationsUrl: string, conversationId: string): string =>
  `${conversationsUrl}/${conversationId}`;

/** A conversation's turns: a POST submits one, refused with a 409 while another is being answered. */
export const agentExchangesUrl = (conversationsUrl: string, conversationId: string): string =>
  `${agentConversationUrl(conversationsUrl, conversationId)}/exchanges`;

/** One turn: a GET reads its status and, once it finished, its answer or its error. */
export const agentExchangeUrl = (conversationsUrl: string, conversationId: string, exchangeId: string): string =>
  `${agentExchangesUrl(conversationsUrl, conversationId)}/${exchangeId}`;
